import { Typography, Stack, Button } from '@mui/material';
import { useEffect } from 'react';
import { handleLogin, removeAuthTokens } from '@/utils/auth';

export interface ErrorProps {
  code?: number;
}

export const AccessDenied = () => {
  // Hide Header login button
  useEffect(() => {
    const headerLoginBtn = document.getElementsByName('login');
    if (headerLoginBtn.length) {
      headerLoginBtn[0].style.display = 'none';
    }
  }, []);

  return (
    <Stack sx={{ py: 4, alignItems: 'center' }}>
      <Typography variant="h6" paragraph={true}>
        Access denied!
      </Typography>

      <Typography variant="body2">
        Your session has expired or you are not authorized to access this page.
      </Typography>

      <Button
        variant="contained"
        color="info"
        sx={{ mt: 2, width: 200 }}
        onClick={async () => {
          removeAuthTokens();
          await handleLogin();
        }}
      >
        Login
      </Button>
    </Stack>
  );
};

export default AccessDenied;
